import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api-client";

export interface GridPnl {
  total_pnl: number;
  total_fee: number;
  funding_total: number;
  trade_count: number;
  score: GridScore | null;
}

export interface GridScore {
  total: number;
  wins: number;
  closed_count: number;
  win_rate_pct: number;
  annualized_roi_pct: number;
  per_trade_bps: number;
  fee_ratio: number;
  age_days: number;
  breakdown: {
    roi: number;
    bps: number;
    fee: number;
    win_rate: number;
  };
}

export function useGridPnl(id: string) {
  return useQuery<GridPnl>({
    queryKey: ["grid-pnl", id],
    queryFn: () => apiGet<GridPnl>(`/grids/${id}/pnl`),
    refetchInterval: 30_000,
    enabled: !!id,
  });
}
